/**
 * Wraps HTMLMediaElement.play() to swallow expected AbortError rejections
 * when playback is interrupted (navigation, tab background, power saving).
 */
export function safePlay(media: HTMLMediaElement): void {
  const playPromise = media.play();

  if (playPromise !== undefined) {
    playPromise.catch(() => {
      // Expected when play() is interrupted by pause(), navigation, or background tab policy.
    });
  }
}
